import * as z from 'zod';

// Types
import { DoudouZod } from '@/components/molecules/Doudou/DoudouType';
import { TitleZod } from '@/types/TitleType';
import { CTAZod } from '@/types/CTAType';
import { WaveWrapperZod } from '@/types/WaveWrapperType';

const DoudouOverviewZod = z.object({
  __component: z.literal('block.doudou-list'),
  id: z.number(),
  title: TitleZod.nullable(),
  cta: CTAZod.nullable(),
  doudous: z.array(DoudouZod).nullable(),
  showFilters: z.boolean(),
  waveWrapper: WaveWrapperZod.nullable(),
});

export { DoudouOverviewZod };
export type DoudouOverviewType = z.infer<typeof DoudouOverviewZod>;
